import React, { createContext, useContext, useState } from 'react'

interface CustomerListContextData {
  showCustomerFilter: boolean
  setShowCustomerFilter: React.Dispatch<React.SetStateAction<boolean>>
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const CustomerListContext = createContext<CustomerListContextData>(
  {} as CustomerListContextData
)

export const CustomerListProvider: React.FC = ({ children }) => {
  const [showCustomerFilter, setShowCustomerFilter] = useState(false)
  const [filters, setFilters] = useState<any>({})

  return (
    <CustomerListContext.Provider
      value={{
        showCustomerFilter,
        setShowCustomerFilter,
        setFilters,
        filters
      }}
    >
      {children}
    </CustomerListContext.Provider>
  )
}

export function useCustomerListContext() {
  return useContext(CustomerListContext)
}
